module.exports = __webpack_public_path__ + "media/theme/sample__psn--sp-8d9cbbbb.png";